module.exports = __webpack_public_path__ + "img/background.96d9cfa1.jpg";